import React from "react";
// import BillingIcon from "../Assets/BillingIcon";
// import ContactIcon from "../Assets/ContactIcon";
// import DashboardIcon from "../Assets/DashboardIcon";
// import FAQIcon from "../Assets/FAQIcon";
import LinkIcon from "../Assets/LinkIcon";
import ListIcon from "../Assets/ListIcon";
import DomainIcon from "../Assets/DomainIcon";
import UpgradeIcon from "../Assets/UpgradeIcon";
import BacklinkIcon from "../Assets/backlinkIcon";
import SettingIcon from "../Assets/SettingIcon";
import BrandingIcon from "../Assets/BrandingIcon";
import TeamIcon from "../Assets/TeamIcon";
import RightIcon from "../Assets/RightIcon.js";
import Logs from "../Assets/Logs.js";

export const SidebarData = [
  // {
  //   title: "Dashboard",
  //   path: "/backlink/dashboard",
  //   icon: <DashboardIcon />,
  // },
  {
    title: "Domain",
    path: "/backlink/domain",
    icon: <DomainIcon />,
  },
  {
    title: "Links",
    path: "/backlink/link",
    icon: <LinkIcon />,
  },
  {
    title: "Lists",
    path: "/backlink/list",
    icon: <ListIcon />,
  },
  {
    title: "Index My Site",
    path: "/backlink/index-me-now",
    new: true,
    icon: <RightIcon />,
    subRoutes: [
      {
        title: "ActivityLogs",
        path: "/backlink/activity-logs",
        icon: <Logs />,
      },
      {
        title: "LinksActivity",
        path: "/backlink/links-activity",
        icon: <Logs />,
      },
    ],
  },
  // {
  //   title: "ActivityLogs",
  //   path: "/backlink/activity-logs",
  //   icon: <Logs />,
  // },
  {
    title: "Pricing",
    path: "/backlink/pricing",
    icon: <UpgradeIcon />,
  },
  // {
  //   title: "Upgrade",
  //   path: "/backlink/upgrade",
  //   icon: <UpgradeIcon />,
  // },
  {
    title: "Manage Team",
    path: "/backlink/manage-team",
    icon: <TeamIcon />,
  },
  {
    title: "Branding",
    path: "/backlink/branding",
    icon: <BrandingIcon />,
  },
  {
    title: "User Api Key",
    path: "/backlink/user-api-keys",
    icon: <SettingIcon />,
  },
  // {
  //   title: "Discover Backlinks",
  //   path: "/backlink/fetch-backlinks",
  //   icon: <BacklinkIcon />,
  // },
  // {
  //   title: "Manage Teams",
  //   path: "/backlink/manage-team",
  //   icon: <DomainIcon />,
  // },
  // {
  //   title: "FAQ",
  //   path: "/backlink/faq",
  //   icon: <FAQIcon />,
  // },
  // {
  //   title: "Contact Support",
  //   path: "/backlink/contact-support",
  //   icon: <ContactIcon />,
  // },
];

export const IndexMeSidebarData = [
  {
    title: "Index My Site",
    path: "/indexme/index-me-now",
    new: true,
    icon: <RightIcon />,
    subRoutes: [
      {
        title: "ActivityLogs",
        path: "/indexme/activity-logs",
        icon: <Logs />,
      },
      {
        title: "LinksActivity",
        path: "/indexme/links-activity",
        icon: <Logs />,
      },
    ],
  },
  // {
  //   title: "Redeem Code",
  //   path: "/indexme/redeem-code",
  //   icon: <UpgradeIcon />,
  // },
  {
    title: "Pricing",
    path: "/indexme/pricing",
    icon: <UpgradeIcon />,
  },
];
